import { render, staticRenderFns } from "./addParkingSpaceApply.vue?vue&type=template&id=b72dc8d4&scoped=true"
import script from "./addParkingSpaceApply.vue?vue&type=script&lang=js"
export * from "./addParkingSpaceApply.vue?vue&type=script&lang=js"
import style0 from "./addParkingSpaceApply.vue?vue&type=style&index=0&id=b72dc8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72dc8d4",
  null
  
)

export default component.exports